export const markAsRead = "gNa";
export default {markAsRead};